<template lang='pug'>
transition-group(
    name='list',
    tag='div',
    :enter-class='animeClass',
    :leave-to-class='animeClass'
)
    .list-item(v-for='(item, index) in list', :key='getKey(item)')
        slot(:item='item')
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default() {
                return []
            }
        },
        rowKey: {
            type: [String, Array],
            required: true
        },
        anime: {
            type: String,
            default: 'scale'
        }
    },
    computed: {
        animeClass() {
            return this.anime.replace(/,/, ' ')
        }
    },
    methods: {
        getKey(item) {
            if (Array.isArray(this.rowKey)) {
                return this.rowKey.map(key => item[key]).join('_')
            }
            return item[this.rowKey]

        }
    }
}
</script>

<style scoped lang='less'>
.opacity {
    opacity: 0;
}
.scale {
    transform: scale(0.1);
}
.translateXLeft {
    transform: translateX(-100%);
}
.translateXRight {
    transform: translateX(100%);
}
.translateYLeft {
    transform: translateY(-100%);
}
.translateYRight {
    transform: translateY(100%);
}
.list-leave-active {
    display: none;
}
.list-move {
    transition: transform 0.5s;
}
.list-item {
    transition: all 0.5s;
}
</style>